import classNames from 'clsx';

import type { PropsWithChildren } from 'react';

import styles from './SectionNotification.module.css';

export interface SectionNotificationProps {
  /** `true` if the notification bar should be full width; otherwise, `false`. */
  fullWidth?: boolean;
}

/** Represents a component to show notifications within a [Card](/story/atoms-card--card-example). */
export const SectionNotification = ({ fullWidth = false, children }: PropsWithChildren<SectionNotificationProps>) => (
  <div
    className={classNames(styles['section-notification'], {
      [styles['section-notification--fullwidth']]: fullWidth,
    })}
  >
    {children}
  </div>
);
